import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/frontend/frontend/src/app/_shared/lib/datadog-init.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/frontend/frontend/src/app/_shared/lib/runtime-init.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/src/app/globals.css");
